import type { Brand } from '@seek/melways-sites';

type PageTitles = {
  [K in Brand]: 'SEEK' | 'Jobsdb' | 'Jobstreet';
};

export const PageTitles: PageTitles = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
} as const;
